import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import colors from 'theme/colors';
import fonts from 'theme/fonts';
import media from 'theme/media';

import { LightDiskButton } from '../../common/fromAuth/LightDiskButton/LightDiskButton';

const SearchBarContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    ${media.tablet720} {
        width: calc(100% - 12px);
    }
`;
const SearchBarContent = styled.div`
    background-color: ${(props) => (props.useThemeColor ? props.theme.white : colors.white)};
    height: auto;
    pointer-events: auto;
    max-width: 528px;
    padding: 0 16px;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    input[type='search'] {
        padding: 24px 16px;
        width: 100%;
        border: none;
        font-size: 17px;
        line-height: 24px;
        background: ${(props) => (props.useThemeColor ? props.theme.white : colors.white)};
        color: ${(props) => (props.useThemeColor ? props.theme.black : colors.black)};
        font-family: ${fonts.regular};
        outline: none;
        -webkit-appearance: none;

        ${media.tablet720} {
            padding: 32px 16px;
            font-size: 20px;
            line-height: 32px;
        }
    }
`;
const Shadow = styled.div`
    box-shadow: ${(props) => (props.useThemeColor ? props.theme.shadow_search : `0 2px 12px 0 ${colors.lightGrayShadow}`)};
    width: 100%;
    height: 16px;
    margin-top: -16px;
    margin-left: auto;
    margin-right: auto;

    ${media.tablet720} {
        max-width: 480px;
    }
`;

export const PromoSearchBar = (props) => {
    return (
        <SearchBarContainer>
            <SearchBarContent useThemeColor={props.useThemeColor}>
                <LightDiskButton iconName="arrow-back" raised={false} type="button" onClick={props.onCloseButtonClick} useThemeColor={props.useThemeColor} />
                <input
                    type="search"
                    name="search"
                    size="100"
                    value={props.value}
                    placeholder={props.placeholder}
                    autoFocus={true}
                    onChange={props.onChange}
                    ref={props.searchRef}
                />
            </SearchBarContent>
            <Shadow />
        </SearchBarContainer>
    );
};

PromoSearchBar.propTypes = {
    onCloseButtonClick: PropTypes.func,
};
